export default __webpack_public_path__ + "static/media/1532.91948159.png";